import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { ISLMap } from 'src/app/types/@types/sl-map';

export interface LoadMapParams {
	handler: AnyHandler;
	map: ISLMap;
}


@Injectable({
	providedIn: 'root'
})
export class LoadMapDialogService {
	public request$: Subject<LoadMapParams> = new Subject();
	constructor() { }


	Show(handler: AnyHandler, map: ISLMap) {
		this.request$.next({
			handler: (handler),
			map: (map)
		});
	}
}
